/** Where a video's picture sits inside its element, for drawing over it. */

export interface Rect {
	height: number;
	width: number;
	x: number;
	y: number;
}

/** Where the picture sits inside the element: `object-contain` letterboxes it. */
export const videoRect = (
	video: HTMLVideoElement,
	width: number,
	height: number,
): null | Rect => {
	if (!video.videoWidth || !video.videoHeight) return null;
	const scale = Math.min(width / video.videoWidth, height / video.videoHeight);
	const shown = {
		height: video.videoHeight * scale,
		width: video.videoWidth * scale,
	};
	return {
		...shown,
		x: (width - shown.width) / 2,
		y: (height - shown.height) / 2,
	};
};
